import {SecureService} from "@/services/superclasses/secure-service";
import {Edition} from "@/interfaces/edition";

const api = window.contextPath + '/rest/editions';

export class EditionSecureService extends SecureService {

    public loadByMember = async (): Promise<Edition[]> => {
        return this.data(await this.get<Edition[]>(api + "/by-member"))
    }
}

export const editionSecureService = new EditionSecureService()